import React from 'react';

import { Appbar } from 'react-native-paper';
import PropTypes from 'prop-types';

const title = {
  en: 'AguaRiego',
  es: 'AguaRiego',
  qu: 'TRANSLATE',
};

export default function Header({ language }) {
  return (
    <Appbar.Header>
      <Appbar.Content
        color="#000000"
        title={title[language]}
        titleStyle={{ fontWeight: 'bold' }}
      />
    </Appbar.Header>
  );
}

Header.propTypes = {
  language: PropTypes.string,
};
